import gql from 'graphql-tag';

export default gql`
  query showsAvailability(
    $showAvailabilitySearchCriteria: ShowAvailabilitySearchInput!
  ) {
    transactionId
    showsAvailability(
      showAvailabilitySearchCriteria: $showAvailabilitySearchCriteria
    ) {
      result {
        useDate
        quantity
        showConditions
      }
      errors
    }
  }
`;
